// pages/LoginPage/LoginPage.js
import React from "react";
import LoginForm from "../../components/LoginForm/LoginForm";
import "./LoginPage.css";
import "../../components/Header/Header.css";

const LoginPage = () => {
  return (
    <div className="login-page">
      {/* <div className='Header-container'>
            <Header />
        </div> */}
      <div className="login-container">
        <LoginForm />
      </div>
    </div>
  );
};

export default LoginPage;
